import { CuiColors } from './types';

export const black = '#000000';
export const white = '#ffffff';

export const purpleDark = '#3417AA';
export const purple = '#4B22F4';
export const purpleMedium = '#6945FF';
export const purpleLight = '#6F4EF6';
export const purpleLighter = '#9C86F9';
export const purpleLighter2 = '#F6F4FE';

export const purpleLighter56 = 'rgba(156,134,249,0.56)';

export const blueLighter = '#878FB8';
export const blueLight = '#1D2559';
export const blueMain = '#181B32';
export const blueDark = '#0F1124';

export const blueLighter8 = 'rgba(135, 143, 184, 0.08)';
export const blueLighter16 = 'rgba(135, 143, 184, 0.16)';
export const blueLighter24 = 'rgba(135, 143, 184, 0.24)';
export const blueLighter56 = 'rgba(135, 143, 184, 0.56)';
export const blueLighter70 = 'rgba(135, 143, 184, 0.70)';

export const blueMain80 = 'rgba(24, 27, 50, 0.80)';

export const grayLighter = '#F6F7F9';
export const grayLight = '#E8EAF0';
export const grayMain = '#C3CBD6';
export const grayDark = '#8D8D9D';

export const grayDark8 = 'rgba(141, 141, 157, 0.08)';
export const grayDark16 = 'rgba(141, 141, 157, 0.16)';
export const grayDark24 = 'rgba(141, 141, 157, 0.24)';
export const grayDark56 = 'rgba(141, 141, 157, 0.56)';
export const grayDark70 = 'rgba(141, 141, 157, 0.70)';

export const redLighter = '#FED5E3';
export const redLight = '#FC81AA';
export const redMain = '#E6215D';
export const redDark = '#930F3B';

export const orangeLighter = '#FFC0B8';
export const orangeLight = '#FF8871';
export const orangeMain = '#E05D1B';
export const orangeDark = '#99441F';

export const yellowLighter = '#FFE0B6';
export const yellowLight = '#FFCD8A';
export const yellowMain = '#FFB200';
export const yellowDark = '#BA7E06';

export const greenLighter = '#DCFFED';
export const greenLight = '#80E0B4';
export const greenMain = '#34D69B';
export const greenDark = '#01605A';

export const primaryLighterHEX = purpleLighter;
export const primaryLightHEX = purpleLight;
export const primaryMainHEX = purple;
export const primaryDarkHEX = purpleDark;

export const primaryLighter = `var(--color-primary-lighter, ${primaryLighterHEX})`;
export const primaryLight = `var(--color-primary-light, ${primaryLightHEX})`;
export const primaryMain = `var(--color-primary-main, ${primaryMainHEX})`;
export const primaryDark = `var(--color-primary-dark, ${primaryDarkHEX})`;

export const secondaryLighterHEX = '#D2FAF6';
export const secondaryLightHEX = '#49F2D2';
export const secondaryMainHEX = '#0BD4C1';
export const secondaryDarkHEX = '#0B756F';

export const secondaryLighter = `var(--color-secondary-lighter, ${secondaryLighterHEX})`;
export const secondaryLight = `var(--color-secondary-light, ${secondaryLightHEX})`;
export const secondaryMain = `var(--color-secondary-main, ${secondaryMainHEX})`;
export const secondaryDark = `var(--color-secondary-dark, ${secondaryDarkHEX})`;

export const baseLighter = blueLighter;
export const baseLight = blueLight;
export const baseMain = blueMain;
export const baseDark = blueDark;

export const baseLighter8 = blueLighter8;
export const baseLighter16 = blueLighter16;
export const baseLighter24 = blueLighter24;
export const baseLighter56 = blueLighter56;
export const baseLighter70 = blueLighter70;

export const baseMain80 = blueMain80;

/* Deprecated. Only used in old files. */
export const primaryColor = purple;
export const primaryText = baseMain;

const colors: CuiColors = {
  transparent: 'transparent',

  black,
  white,

  primary: {
    lighter: primaryLighter,
    light: primaryLight,
    main: primaryMain,
    dark: primaryDark,
  },
  secondary: {
    lighter: secondaryLighter,
    light: secondaryLight,
    main: secondaryMain,
    dark: secondaryDark,
  },
  base: {
    lighter: baseLighter,
    light: baseLight,
    main: baseMain,
    dark: baseDark,

    'lighter-8': baseLighter8,
    'lighter-16': baseLighter16,
    'lighter-24': baseLighter24,
    'lighter-56': baseLighter56,
    'lighter-70': baseLighter70,

    'main-80': baseMain80,
  },

  purple: {
    dark: purpleDark,
    main: purple,
    medium: purpleMedium,
    light: purpleLight,
    lighter: purpleLighter,
    'lighter-2': purpleLighter2,
  },

  gray: {
    lighter: grayLighter,
    light: grayLight,
    main: grayMain,
    dark: grayDark,

    'dark-8': grayDark8,
    'dark-16': grayDark16,
    'dark-24': grayDark24,
    'dark-56': grayDark56,
    'dark-70': grayDark70,
  },

  red: {
    lighter: redLighter,
    light: redLight,
    main: redMain,
    dark: redDark,
  },
  orange: {
    lighter: orangeLighter,
    light: orangeLight,
    main: orangeMain,
    dark: orangeDark,
  },
  yellow: {
    lighter: yellowLighter,
    light: yellowLight,
    main: yellowMain,
    dark: yellowDark,
  },
  green: {
    lighter: greenLighter,
    light: greenLight,
    main: greenMain,
    dark: greenDark,
  },

  rgba: {
    'purple-lighter-56': purpleLighter56,
  },

  inherit: 'inherit',
};

export default colors;
